import { render, staticRenderFns } from "./clientNoWindow.vue?vue&type=template&id=5353b542&"
import script from "./clientNoWindow.vue?vue&type=script&lang=js&"
export * from "./clientNoWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5353b542')) {
      api.createRecord('5353b542', component.options)
    } else {
      api.reload('5353b542', component.options)
    }
    module.hot.accept("./clientNoWindow.vue?vue&type=template&id=5353b542&", function () {
      api.rerender('5353b542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/role/clientNoWindow.vue"
export default component.exports